import { isEmpty } from "lodash"
import { useSelector } from "react-redux"
import { CircularProgress } from "@mui/material"
import { actions } from "store"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { BatteryRM } from "models/RM"
import { app } from "router/routes"

const useBatteryAllocationBtn = () => {
    const { selectedTestTakers } = useSelector(state => state.testTaker)
    const { selectedAssessmentDefs, createBatteryIsRun } = useSelector(state => state.assessment)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const batteryAllocation = async () => {
        dispatch(actions.setCreateBatteryIsRun(true))
        // let nSelectedAssessmentDefs = selectedAssessmentDefs.map((assessmentDef) => assessmentDef.id)

        const battery = new BatteryRM({ test_takers: selectedTestTakers, assessment_defs: selectedAssessmentDefs })
        await dispatch(actions.allocationBattery(battery))
        dispatch(actions.setCreateBatteryIsRun(false))
        dispatch(actions.setSelectedAssessmentDefs([]))
        dispatch(actions.setSelectedTestTakers([]))
        navigate(app.allAssessments)
    }

    const batteryAllocationBtn = {
        id: 1,
        color: "secondary",
        label: createBatteryIsRun ? <CircularProgress color="white" size={20} /> : "הקצאה",
        action: batteryAllocation,
        disabled: isEmpty(selectedAssessmentDefs),
        disabledColor: "secondary",
        width: '150px'
    }

    return batteryAllocationBtn
}

export default useBatteryAllocationBtn